import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { injectIntl, defineMessages, intlShape } from 'react-intl'
import Select from 'components/Select'
import WorkspaceFormInput from 'workspace/WorkspaceFormInput'
import { changeFormData } from 'workspace/actions'

const messages = defineMessages({
  yes: {
    id: 'workspace.form.productionStop.yes',
    defaultMessage: 'Yes',
    description: 'Production stop YES option in the new breakdown form'
  },
  no: {
    id: 'workspace.form.productionStop.no',
    defaultMessage: 'No',
    description: 'Production stop NO option in the new breakdown form'
  }
})

const WorkspaceFormProductionStop = ({ value, onChange, intl, disabled }) => {
  const options = [
    { value: true, label: intl.formatMessage(messages.yes) },
    { value: false, label: intl.formatMessage(messages.no) }
  ]
  const selected = options.find(option => option.value === value) || null

  return (
    <WorkspaceFormInput attribute='productionStop'>
      <Select
        options={options}
        value={selected}
        onChange={option => onChange({ productionStop: option ? option.value : null })}
        isClearable={false}
        isDisabled={disabled}
        backspaceRemovesValue={false}
      />
    </WorkspaceFormInput>
  )
}

WorkspaceFormProductionStop.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  intl: intlShape,
  disabled: PropTypes.bool
}

const mapStateToProps = state => ({
  value: state.form.data.productionStop
})

const mapDispatchToProps = ({
  onChange: changeFormData
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(WorkspaceFormProductionStop)
